import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-page',
  templateUrl: './footer-page.component.html',
  styleUrls: ['./footer-page.component.scss']
})
export class FooterPageComponent implements OnInit {

  constructor() { }
  currentyear: number = new Date().getFullYear();
  ngOnInit(): void {
  }

  ngAfterViewInit() {

  }

}
